import React from 'react';
import './AutocompleteSpan.css';


// Autocomplete span
const AutocompleteSpanComponent = (props: { children: React.ReactNode }) => {
  return (
    <span className="autocomplete-text">
      {props.children}
    </span>
  );
};


export default AutocompleteSpanComponent;